import React, { useState } from 'react';
import {
    Button,
    Card,
    CardBody,
    Col,
    ModalFooter,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane
} from 'reactstrap';

export const ModalViewView = (props) => {

    const { toggleRol, listRolesData } = props;

    const [verticalTab, setVerticalTab] = useState('1');

    return (
        <>
<Row className='roles-container'>

    <Col lg="5">

        <div className='modules-panel'>

            <div className='panel-title'>
                Módulos
            </div>

            <Nav className='modules-list'>

                {
                    listRolesData?.map((obj, index) => {

                        const tabId = String(index + 1);

                        return (

                            <NavItem key={index}>

                                <NavLink
                                    className={`module-item ${
                                        verticalTab === tabId
                                            ? 'active-module'
                                            : ''
                                    }`}
                                    onClick={() => setVerticalTab(tabId)}
                                >

                                    <div className='module-name'>
                                        <i className='fa fa-folder me-2'/>
                                        {obj.name}
                                    </div>

                                    <span className='module-badge'>
                                        {obj.views?.length || 0}
                                    </span>

                                </NavLink>

                            </NavItem>

                        );
                    })
                }

            </Nav>

        </div>

    </Col>


    <Col lg="7">

        <div className='views-panel'>

            <div className='panel-title success'>
                Vistas disponibles
            </div>

            <TabContent activeTab={verticalTab}>

                {
                    listRolesData?.map((obj, index) => {

                        const tabId = String(index + 1);

                        return (

                            <TabPane
                                tabId={tabId}
                                key={index}
                            >

                                <div className='views-grid'>

                                    {
                                        obj.views?.map((view, keyView) => (

                                            <div
                                                className='view-card'
                                                key={keyView}
                                            >

                                                <div className='view-icon'>
                                                    <i className='fa fa-file-text'/>
                                                </div>

                                                <div className='view-info'>

                                                    <div className='view-title'>
                                                        {view.name}
                                                    </div>

                                                    <small>
                                                        Vista asignada
                                                    </small>

                                                </div>

                                            </div>

                                        ))
                                    }

                                </div>

                            </TabPane>

                        );
                    })
                }

            </TabContent>

        </div>

    </Col>

</Row>

        </>
    );
}